import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-quiz-taking',
  templateUrl: './quiz-taking.component.html',
  styleUrl: './quiz-taking.component.css'
})
export class QuizTakingComponent {

  quizzes: any[] = [];
  currentUser: any;
  quiz: any;
  safeVideoUrl: SafeResourceUrl | null = null;
  quizForm: FormGroup;
  questionsFormArray: FormArray = this.fb.array([]);
  videoUrl: string | null = null;
  constructor(private d: DataserviceService, private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private message: NzMessageService, private sanitizer: DomSanitizer) {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.quizForm = this.fb.group({
      questions: this.questionsFormArray
    });
    this.route.params.subscribe((params: any) => {
      this.getQuizById(params.id);
    });
  }

  ngOnInit() {
    this.getQuizById(this.route.snapshot.params['id']);
  }

  getQuizById(id: string) {
    this.d.getData('quizzes/' + id).subscribe((res: any) => {
      this.quiz = res.data;
      this.setVideoUrl(this.quiz?.video_url);
      this.resetQuestions();
      if (this.quiz?.questions?.length) {
        this.quiz.questions.forEach((q: any) => {
          this.questionsFormArray.push(this.fb.group({
            question: [q.question || ''],
            answer: ['', Validators.required]
          }));
        });
      }
    });
  }

  submitQuiz() {
    if (this.quizForm.invalid) {
      this.message.error('Please answer all questions before submitting.');
      return;
    }
    this.d.postData({ quiz_id: this.quiz.id, user_id: this.currentUser.id, answers: this.quizForm.value }, 'quizzes/submit-quiz').subscribe((res: any) => {
      if (res.result === 'success') {
        this.router.navigate(['/onboarding']);
      } else {
        this.message.error(res.message);
      }
    });
  }

  backToOnboarding() {
    this.router.navigate(['/onboarding']);
  }

  private resetQuestions() {
    while (this.questionsFormArray.length) {
      this.questionsFormArray.removeAt(0);
    }
  }

  private async setVideoUrl(url?: string) {
    this.safeVideoUrl = null;
    this.videoUrl = null; 
    
    if (!url) return;

    const path = this.extractObjectPath(url);
    let finalUrl = url; 

    if (path) {
      try {
        const res = await lastValueFrom(this.d.resolveVideoUrl(path));
        
        if (res.result === 'success') {
          finalUrl = res.url;
          console.log(`Using ${res.type} URL:`, finalUrl);
        }
      } catch (err) {
        console.warn('Could not resolve path through API, using fallback:', url);
      }
    }

    // Set values and sanitize for the iframe/video player
    this.videoUrl = finalUrl;
    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
  }

  private extractObjectPath(pathOrUrl: string): string | null {
    if (!pathOrUrl) return null;

    // If it looks like a full URL, extract the path
    if (pathOrUrl.startsWith('http')) {
      // Try to match Supabase storage URL pattern
      const match = pathOrUrl.match(/\/storage\/v1\/object\/sign\/training\/([^?]+)/) ||
        pathOrUrl.match(/\/training\/([^?]+)/) ||
        pathOrUrl.match(/storage\.supabase\.co\/.*\/training\/([^?]+)/);
      if (match && match[1]) {
        return decodeURIComponent(match[1]);
      }
      return null;
    }

    // If it's already just an object path, clean and return it
    // Remove leading slashes and any bucket prefix
    return pathOrUrl.trim().replace(/^\/+/, '').replace(/^training\//, '');
  }

}
